export enum TableFilterEqualityOperator {
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  Contains = 'Contains',
  NotContains = 'NotContains',
  LargerThan = 'LargerThan',
  LowerThan = 'LowerThan',
}

export enum TableRangeOperator {
  BetweenRange = 'BetweenRange',
}

export enum TableFilterConditionsConnection {
  And = 'And',
  Or = 'Or',
}
